import { useLocation } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';

import { twMerge } from 'tailwind-merge';

import AuthShell from '../components/Auth/AuthShell';
import VerifyEmailScreen from '../components/Auth/VerifyEmailScreen';
import { BaseButton } from '../components/Buttons/BaseButton';
import { AUTH_GREEN_BUTTON_CLASSES } from '../constants/Auth';

/**
 * Unauthenticated landing page for Auth0 redirects that came back with an
 * error instead of a code (`/auth-error?error=...&message=...`). It lives
 * outside the `withAuthenticationRequired` tree on purpose: that HOC calls
 * `loginWithRedirect` for any unauthenticated visitor, which Auth0 answers
 * with the same error — an infinite redirect loop unless the error lands on
 * a public page like this one.
 */
export const AuthError = () => {
  const { search } = useLocation();
  const { loginWithRedirect } = useAuth0();

  const params = new URLSearchParams(search);
  const error = params.get('error');
  const message = params.get('message') ?? params.get('error_description');

  const retrySignIn = () => loginWithRedirect();

  if (error === 'email_not_verified') {
    return <VerifyEmailScreen onSignIn={retrySignIn} />;
  }

  return (
    <AuthShell
      heading="We couldn't sign you in"
      subheading={message ?? 'Something went wrong during sign-in.'}
    >
      <div className="flex flex-col items-center gap-6 text-center">
        <BaseButton
          className={twMerge('w-full text-white', AUTH_GREEN_BUTTON_CLASSES)}
          onClick={retrySignIn}
        >
          Try again
        </BaseButton>
      </div>
    </AuthShell>
  );
};
